// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"59":"0df1e5e65eb3f100e233","374":"7bb042f26f99c6049699"}[chunkId] + ".js";
};